export default __webpack_public_path__ + "static/media/655.61e97565.gif";